export default "__VITE_ASSET__BhQrvHTq__"